





















































































/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */

import { Component, Vue, Prop } from 'vue-property-decorator';
import local_localesData from './locale';
import DO_MODIFY from './service';
import INFO from '../../library/API/GetBranch';
import showLang from './showLang';
/** 存在本地端的語言列表 */
type locale_res = {
  p11_lle_code: string;
  p11_lle_id: number;
  p11_lle_name: string;
  p11_lle_status: '3' | '-2';
};

interface locale_res_f extends locale_res {
  flag: string;
}

@Component
export default class langChanger extends Vue {
  private locales: any = [];

  /** 要顯示的語系code */
  private showLang = showLang;

  public dialog: boolean = false;

  private currentLocale: locale_res_f = {
    p11_lle_code: '',
    p11_lle_id: 0,
    p11_lle_name: '',
    p11_lle_status: '3',
    flag: '',
  };

  public async doModify(id: number) {
    const self = this;
    const getter = new DO_MODIFY(id);

    await getter.put().then((isOK: Boolean) => {
      if (isOK) {
        this.getInfo();
        return;
      }
      this.$message.error('Error: language change error.');
    });
  }

  /**
   * getInfo
   */
  public getInfo() {
    const self = this;
    const getter = new INFO();

    getter.get().then(() => {
      const localeListOrgin = localStorage.getItem('locale_list') || '{}';
      const localeList_f = JSON.parse(localeListOrgin) || [];

      const localeList = localeList_f.map((x: locale_res) => {
        /** 從本地端列表找到對應後端語言列表的項目，並且擴充其flag屬性 */
        const finded = local_localesData.find(
          l => l.value === x.p11_lle_code,
        );
        const locale_result: any = x;

        if (finded) {
          locale_result.flag = finded.flag;
        }
        return locale_result;
      });
      /** 整理有翻譯的才顯示 */
      const locale = localeList.filter((key: any) => this.showLang.includes(key.p11_lle_code));
      // 在過濾出不重復的
      // eslint-disable-next-line max-len
      self.locales = locale.filter((item:any, index:any, that:any) => index === that.findIndex((t:any) => t.p11_lle_code === item.p11_lle_code));
      const lang = localStorage.getItem('lang');
      if (lang) {
        this.setLang(lang);
        this.$i18n.locale = lang;
      }
    });
  }

  /**
   * setLang 顯示目前的地區語言設定
   */
  public setLang(locale: string | null): void {
    if (locale) {
      [this.currentLocale] = this.locales.filter(
        (obj: locale_res_f) => obj.p11_lle_code === locale,
      );
      this.$emit('change', this.currentLocale);
    }
  }

  public async change(country: locale_res_f) {
    if (country) {
      await this.doModify(country.p11_lle_id);
      this.$i18n.locale = country.p11_lle_code;
      localStorage.setItem('lang', country.p11_lle_code);
      this.$router.go(0);
    }
  }

  public mounted() {
    /** 接收bus訊號，並改變自身的dialog顯示狀態 */
    this.$bus.$on('language', (status: boolean) => {
      this.dialog = status;
    });
    setTimeout(() => {
      this.getInfo();
    }, 1000);
  }
}
